import { render, staticRenderFns } from "./HeaderColumn.vue?vue&type=template&id=46c0bada&scoped=true&"
import script from "./HeaderColumn.vue?vue&type=script&lang=ts&"
export * from "./HeaderColumn.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderColumn.vue?vue&type=style&index=0&id=46c0bada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0bada",
  null
  
)

export default component.exports